import { Box, Tabs } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Navigate, Route, Routes, resolvePath, useLocation, useSearchParams } from 'react-router-dom';
import { PaloThemeProvider, tokens } from '@synergy/theme-palo';
import { PoolDocumentTitle } from '@synergy/components-next';
import { PoolTab } from '@synergy/components';
import { ReactElement } from 'react';
import urlJoin from 'url-join';

import { NotificationSettings } from './components/notifications/notifications-settings';
import { SettingsTab } from './settings-tab';
import { SystemSettings } from './components/system/system-settings';

export const AppSettings = (): ReactElement => {
    const location = useLocation();

    const [searchParams] = useSearchParams();

    return (
        // The same head every other screen has. This one still wore the legacy
        // toolbar, which put a pale blue band above the only page that has no
        // toolbar actions at all.
        <PaloThemeProvider>
            <Box
                sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: tokens.color.canvas,
                }}
            >
                <PoolDocumentTitle titleTranslationId={'app.navigation.settings'} />
                <Box
                    sx={{
                        backgroundColor: tokens.color.surface,
                        borderBottom: `1px solid ${tokens.color.line}`,
                        padding: '11px 16px 0',
                        flexShrink: 0,
                    }}
                >
                    <Box
                        sx={{
                            fontSize: '17px',
                            fontWeight: 640,
                            letterSpacing: '-.015em',
                            color: tokens.color.ink,
                            mb: '11px',
                        }}
                    >
                        <FormattedMessage id="app.navigation.settings" />
                    </Box>
                    <Tabs indicatorColor="primary" value={location.pathname}>
                        {Object.values(SettingsTab).map(item => (
                            <PoolTab
                                value={urlJoin('/', resolvePath(item, 'settings').pathname)}
                                linkTo={{ pathname: item, search: searchParams.toString() }}
                                label={<FormattedMessage id={'app.settings.' + item} />}
                                key={item}
                            />
                        ))}
                    </Tabs>
                </Box>

                <Routes>
                    <Route
                        index={true}
                        element={
                            <Navigate
                                to={{ pathname: SettingsTab.System, search: searchParams.toString() }}
                                replace={true}
                            />
                        }
                    />
                    <Route path={SettingsTab.System} element={<SystemSettings />} />
                    <Route path={SettingsTab.Notifications} element={<NotificationSettings />} />
                </Routes>
            </Box>
        </PaloThemeProvider>
    );
};
